import { render } from "./ContactStepContent.vue?vue&type=template&id=b840b79e"
import script from "./ContactStepContent.vue?vue&type=script&lang=js"
export * from "./ContactStepContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__